import { useApiQuery } from 'hooks/useApiQuery'
import { removeUndefined } from 'utils/util'

export const useGetRedrawnPatrons = ({
  sweepstakeDrawingId,
}: {
  sweepstakeDrawingId?: number
}) => {
  const queryArgs = removeUndefined({ sweepstakeDrawingId })

  return useApiQuery({
    method: 'get',
    path: '/admin/sweepstake-winners/sweepstake-drawing/{sweepstakeDrawingId}/ineligible',
    queryKey: [
      '/admin/sweepstake-winners/sweepstake-drawing/{sweepstakeDrawingId}/ineligible',
    ],
    queryArgs,
  })
}
